/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Fragment } from 'react'

import type { AnyCluster, CCMService } from '@modules/ccm-lib/types'
import { FormattedMessage } from '@modules/i18n'

// eslint-disable-next-line import/no-restricted-paths
import ExternalLink from '@/components/ExternalLink'

import type { FC } from 'react'

type Props = {
  cluster: AnyCluster
  serviceName: CCMService
}

const OptionalDocumentationLink: FC<Props> = ({ cluster, serviceName }) => {
  if ('metadata' in cluster.services[serviceName]) {
    return (
      <Fragment>
        {' '}
        <ExternalLink href={cluster.services[serviceName].metadata.documentation_url}>
          <FormattedMessage id='ccm.cluster-services.learn-more-link' defaultMessage='Learn more' />
        </ExternalLink>
      </Fragment>
    )
  }

  return null
}

export default OptionalDocumentationLink
